// Shared data source for case study previews used across the site
// (homepage section, related-case-studies widget, /case-studies index).
// Edit case-study metadata here in one place.

export const caseStudies = [
  {
    route: '/case-study-exeter-office-g-to-a',
    label: 'Period Office · G189 → A25',
    headline: 'Period office in Exeter: G to Band A roadmap',
    area: '364.9 m²',
    location: 'Exeter, Devon',
    ratingFrom: 'G189',
    ratingTo: 'A25',
    summary:
      'Five-option improvement pathway with full financial payback analysis. Listed Victorian period building modelled in SBEM, demonstrating that even the most challenging heritage stock can reach Band A with the right staged plan.',
    tags: ['MEES', 'Heritage', 'SBEM', '5-option payback'],
    type: 'commercial',
  },
  {
    route: '/case-study-exeter-office-workshop',
    label: 'Office + Workshop · 793 m²',
    headline: 'Office & workshop near Exeter: oil to electric pathway',
    area: '793 m²',
    location: 'Near Exeter, Devon',
    ratingFrom: 'D-grade',
    ratingTo: 'Compliant',
    summary:
      'Mixed office and workshop premises with oil boiler heating. SBEM-modelled improvements covering oil boiler replacement, LED lighting upgrade and fabric measures with full MEES compliance recommendations for the landlord.',
    tags: ['Mixed-use', 'Oil heating', 'LED', 'MEES'],
    type: 'commercial',
  },
  {
    route: '/case-study-exeter-workshop-refurbishment',
    label: 'Twin Workshops · D → B',
    headline: 'Twin industrial units near Exeter: D to Band B refurb',
    area: '2 × 185.7 m²',
    location: 'Exeter, Devon',
    ratingFrom: 'Band D',
    ratingTo: 'Band B',
    summary:
      'Twin industrial workshop refurbishment with LED lighting, AC heat pump heating and roof / wall insulation upgrades. SBEM modelling demonstrating Band B compliance ready for the proposed 2030 commercial standard.',
    tags: ['Industrial', 'Heat pump', 'Insulation', 'Band B'],
    type: 'commercial',
  },
  {
    route: '/case-study-london-mees-unit-split',
    label: 'London E2 9DG · G242 → B',
    headline: 'London commercial split: G to Band B with solar pathway',
    area: '431 m² split into 3 units',
    location: 'London E2 9DG',
    ratingFrom: 'G242',
    ratingTo: 'Band B',
    summary:
      'Poorly insulated solid-brick commercial building with flat concrete roof and mixed gas/electric heating. Staged unit-split improvement plan taking the property from G242 through Band E and on to Band B with a solar PV pathway to A.',
    tags: ['MEES', 'Unit split', 'Solid wall', 'Solar PV'],
    type: 'commercial',
  },
  {
    route: '/case-study-sticklepath-sap-conversion',
    label: 'Sticklepath Devon · SAP · EPC E (40)',
    headline: 'Devon stone outbuilding conversion: as-built SAP for 1-bed holiday let',
    area: '36.1 m²',
    location: 'Sticklepath, Devon',
    ratingFrom: 'As-built',
    ratingTo: 'E (40) → E (54)',
    summary:
      'Retrospective SAP 10.2 calculation for a 36.1 m² stone outbuilding converted into a 1-bed holiday let. Excellent fabric (U-values 0.13–0.16 W/m²K) let down by all-electric panel heaters. MEES compliant, with a clear pathway to Band C for the 2030 standard.',
    tags: ['SAP 10.2', 'New conversion', 'Holiday let', 'Building Control sign-off'],
    type: 'sap',
  },
];
